import { render, staticRenderFns } from "./monthly-milling-avg.card.vue?vue&type=template&id=5eb2c508&"
import script from "./monthly-milling-avg.card.vue?vue&type=script&lang=js&"
export * from "./monthly-milling-avg.card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports